import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import AnimateButton from "components/animateButton";

interface Props {
  title: string;
  children: any;
  visible: boolean;
  onClose: Function;
  onConfirm: Function;
}

const DeleteEditModal = (props: Props) => {
  return (
    <Dialog
      open={props.visible}
      onClose={() => props.onClose()}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle
        id="confirm-dialog-title"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          px: 3,
          py: 2,
          fontSize: 20,
          fontWeight: 600,
          lineHeight: 1.4,
        }}
      >
        {props.title}
        <IconButton
          aria-label="close"
          onClick={() => props.onClose()}
          size="small"
          sx={{ color: "text.secondary" }}
        >
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ px: 3, py: 1 }}>
        <DialogContentText
          id="confirm-dialog-description"
          sx={{
            color: "text.primary",
            fontSize: 16,
            lineHeight: 1.5,
          }}
        >
          {props.children}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "space-between",
          px: 3,
          py: 2,
        }}
      >
        <Button
          disableElevation
          size="large"
          type="button"
          variant="outlined"
          color="secondary"
          onClick={() => props.onClose()}
        >
          Cancel
        </Button>
        <AnimateButton>
          <Button
            disableElevation
            size="large"
            type="button"
            variant="contained"
            color="secondary"
            onClick={() => props.onConfirm()}
          >
            Confirm
          </Button>
        </AnimateButton>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(DeleteEditModal);
